import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const GroupTitleDescriptionStyled = styled.p.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "group-title-description",
})`
  font-size: 12px;
  color: ${greyMui._700};
`;
